import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsx as _jsx } from "preact/jsx-runtime";
/**
 * Style a title for a Card
 */
export default function CardTitle({
  children,
  classes,
  elementRef,
  tagName = 'h1',
  variant = 'primary',
  ...htmlAttributes
}) {
  const WrapperElement = tagName;
  return _jsx("div", {
    "data-component": "CardTitle",
    ...htmlAttributes,
    className: classnames({
      'text-lg text-brand font-semibold': variant === 'primary',
      'text-xl text-slate-7 font-normal': variant === 'secondary'
    }, classes),
    ref: downcastRef(elementRef),
    children: _jsx(WrapperElement, {
      "data-testid": "card-title-heading",
      children: children
    })
  });
}
//# sourceMappingURL=CardTitle.js.map